import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './SetPreferences.css';
import Body from '../../components/Body/Body';
import Formbox from '../../components/Formbox/Formbox';
import ShareGridient from '../../components/ShareGridient/ShareGridient';

const ThankYouNoRegistrationsleft = () => {
    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header" style={{ textAlign: 'center' }}>
                        <h1 style={{ color: 'green' }}>Thank You!</h1>
                        <p>Your preferences have been set successfully.</p>
                        <p>All resources have been Enrolled</p>
                        <ShareGridient />
                    </div>
                </div>
            </section>
        </div>
    );
}
const ThankYouRegistrationsleft = ({ pending_links, resources_enrolled }) => {
    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header" style={{ textAlign: 'center' }}>
                        <h1 style={{ color: 'green' }}>Thank You!</h1>
                        <p>Thanks You for enrolling {resources_enrolled.map(resource =>(
                            <span>{resource.make} {resource.model} {resource.year}</span>
                        ))}</p>
                        <p>Click next in order to complete your next asset registration</p>
                        <div className="button-container">
                            <button
                                type="button"
                                onClick={() => {
                                    window.location.href = pending_links[0].link
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
const SetPreferencesForDevices = ({ pending_resources }) => {
    const deviceCount = pending_resources.resources_updated.length;
    const headerTitle = deviceCount === 1
        ? "You Have Successfully Registered the Device"
        : "You Have Successfully Registered the Devices";
    const updatedResources = pending_resources.resources_updated.map((resource, index) => (
        <p key={index}>{resource.make} {resource.model}</p>
    ));

    const [submittedCount, setSubmittedCount] = useState(0);
    const handleFormSubmitted = () => {
        setSubmittedCount(prev => prev + 1);
    };

    // Once all forms are submitted, show Thank You screen based on conditions.
    if (submittedCount === deviceCount) {
        if (pending_resources.pending_links && pending_resources.pending_links.length > 0) {
            return <ThankYouRegistrationsleft pending_links={pending_resources.pending_links} resources_enrolled={pending_resources.resources_updated} />;
        }
        return <ThankYouNoRegistrationsleft />;
    }

    const forms = pending_resources.resources_updated.map((resource, index) => (
        <SetPreferencesForm key={index} resource={resource} onFormSubmitted={handleFormSubmitted} />
    ));

    return (
        <div>
            <section>
                <div className="inner">
                    <div className="wizard-header" style={{ textAlign: 'center' }}>
                        <h1 style={{ color: 'green' }}>{headerTitle}</h1>
                        <h2>Please set your preferences below</h2>
                    </div>
                </div>
                {forms}
            </section>
        </div>
    );
}
const SetPreferencesForm = ({ resource, onFormSubmitted }) => {
    const resourceType = resource.asset_type;
    const resourceId = resource.resource_id;
    const userId = resource.userId;

    if (resourceType === 'hvac') {
        var defaultSchedule = {
            Temp_Difference: 5,
            asset_type: resourceType,
        }
    }
    else if (resourceType === 'vehicle') {
        var defaultSchedule = {
            MON: { departure_time: "08:00", departure_soc: 80 },
            TUE: { departure_time: "08:00", departure_soc: 80 },
            WED: { departure_time: "08:00", departure_soc: 80 },
            THU: { departure_time: "08:00", departure_soc: 80 },
            FRI: { departure_time: "08:00", departure_soc: 80 },
            SAT: { departure_time: "09:00", departure_soc: 90 },
            SUN: { departure_time: "09:00", departure_soc: 90 },
            asset_type: resourceType,
        }
    }
    else if (resourceType === 'battery') {
        var defaultSchedule = {
            minimum_soc: 50,
            asset_type: resourceType,
        }
    }

    const [schedule, setSchedule] = useState(defaultSchedule);
    const [submitted, setSubmitted] = useState(false);
    const [calledCallback, setCalledCallback] = useState(false);

    const handleInputChange = (day, field, value) => {
        var currentSchedule = { ...schedule };
        if (day) {
            currentSchedule[day][field] = value;
        }
        else {
            currentSchedule[field] = value;
        }
        setSchedule(currentSchedule); 

    };

    const handleSubmit = async () => {
        const ENROLLMENT_API_URL = process.env.REACT_APP_BACKEND_BASE;
        try {
            schedule.asset_type = resourceType; // Add asset_type to the schedule object
            const response = await fetch(`${ENROLLMENT_API_URL}/push_resource_preference/${userId}/${resourceId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(schedule),
            });
            if (response.ok && !submitted) {
                setSubmitted(true);
                if (onFormSubmitted && !calledCallback) {
                    onFormSubmitted();
                    setCalledCallback(true);
                }
            }
        } catch (error) {
            console.error("Submit error:", error);
        }
    };

    if (submitted) return null;

    return (
        <div className="inner">
            <div className="wizard-header" style={{ textAlign: 'center' }}>
                <h3>{resource.make} {resource.model}</h3>
                <form className='form-preferences'>
                    <div className='preferences-form'>
                        {resourceType === 'hvac' && (
                            <div className='rectangle' key='Temp_Difference'>
                                <div className="form-holder" style={{ padding: '10px' }}>
                                    <label>Maximum Thermostat Temperature Difference:</label>
                                    <input
                                        type="number"
                                        value={schedule.Temp_Difference}
                                        onChange={(e) => handleInputChange(null, 'Temp_Difference', parseInt(e.target.value))}
                                    />
                                </div>
                            </div>
                        )}
                        {resourceType === 'vehicle' && (
                            <>
                                {['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'].map(day => (
                                    <div className='rectangle' key={day}>
                                        <div className="form-holder" style={{ padding: '10px' }}>

                                            <legend>{day}</legend>
                                            <label>Departure Time:</label>
                                            <input
                                                type="time"
                                                value={schedule[day].departure_time}
                                                onChange={(e) => handleInputChange(day, 'departure_time', e.target.value)}
                                            />
                                            <label>Departure Vehicle Percentage:</label>
                                            <input
                                                type="number"
                                                value={schedule[day].departure_soc}
                                                onChange={(e) => handleInputChange(day, 'departure_soc', parseInt(e.target.value))}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </>
                        )}
                        {resourceType === 'battery' && (
                            <div className='rectangle' key='Temp_Difference'>
                                <div className="form-holder" style={{ padding: '10px' }}>
                                    <label>Minimum Battery Percentage:</label>
                                    <input
                                        type="number"
                                        value={schedule.minimum_soc}
                                        onChange={(e) => handleInputChange(null, 'minimum_soc', parseInt(e.target.value))}
                                    />
                                </div>
                            </div>
                        )}

                    </div>
                    <div className="button-container">
                        <button type="button" onClick={handleSubmit}>
                            Submit Preferences
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const SetPreferences = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const partner = searchParams.get("partner");
    const assetType = searchParams.get("asset_type");
    const tempPass = searchParams.get("temp_pass");
    const userId = searchParams.get("user_id");
    const [returnValue, setReturnValue] = useState(null);


    const [pendingResources, setPendingResources] = useState(null); // state for fetched pending resources

    // Function to call API using fetch
    const fetchPendingResourceSetups = async () => {
        const BACKEND = process.env.REACT_APP_BACKEND_BASE; // Use environment variable for API endpoint 
        // const BACKEND = 'https://enrollment-be.dev.gridient.io'; // Replace with your actual API endpoint
        const url = `${BACKEND}/get_pending_resource_setups/${userId}/${tempPass}/${partner}`;
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "User-Agent": "insomnia/11.0.1"
                }
            });
            const data = await response.json();
            setPendingResources(data); // update state with fetched data
        } catch (error) {
            console.error("API error:", error);
        }
    };

    // Call API function when partner, tempPass and userId are available
    useEffect(() => {
        if (partner && tempPass && userId) {
            fetchPendingResourceSetups();
        }
    }, [partner, tempPass, userId]);
    useEffect(() => {
        if (pendingResources) {
            // Assign pendingResources to a new variable and filter it
            const modifiedPendingResources = { ...pendingResources };
            const allowedAssetTypes = ['vehicle', 'battery', 'hvac'];
            modifiedPendingResources.resources_updated = modifiedPendingResources.resources_updated.filter(resource =>
                allowedAssetTypes.includes(resource.asset_type)
            );
            if (
                modifiedPendingResources.resources_updated.length === 0 &&
                modifiedPendingResources.pending_links.length === 0
            ) {
                setReturnValue(<ThankYouNoRegistrationsleft />);
            } else if (
                modifiedPendingResources.resources_updated.length === 0 &&
                modifiedPendingResources.pending_links.length > 0
            ) {
                setReturnValue(<ThankYouRegistrationsleft pending_links={modifiedPendingResources.pending_links} resources_enrolled = {pendingResources.resources_updated} />);
            } else if (modifiedPendingResources.resources_updated.length > 0) {
                setReturnValue(<SetPreferencesForDevices pending_resources={modifiedPendingResources} />);
            }
        }
    }, [pendingResources]);




    return (
        <div>
            <Body elements={
                <Formbox elements={returnValue}>
                </Formbox>
            }>
            </Body>
        </div>
    );
}

export default SetPreferences;